import { useState } from 'react'
import { ClipboardCheck, ScanEye, ShieldCheck } from 'lucide-react'
import { KnowledgeAuditPanel } from './KnowledgeAuditPanel'
import { SelfAuditPanel } from './SelfAuditPanel'
import { AuditPanel } from './AuditPanel'

const TABS = [
  { id: 'knowledge', label: 'Knowledge', icon: ClipboardCheck },
  { id: 'self', label: 'Self Audit', icon: ScanEye },
  { id: 'security', label: 'Security', icon: ShieldCheck },
] as const

type TabId = typeof TABS[number]['id']

export function AuditCentrePanel() {
  const [activeTab, setActiveTab] = useState<TabId>('knowledge')

  return (
    <div className="space-y-4">
      <div className="flex gap-1 p-1 bg-surface-elevated border border-border rounded-xl">
        {TABS.map((tab) => {
          const Icon = tab.icon
          const isActive = activeTab === tab.id
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 flex items-center justify-center gap-2 min-h-[44px] px-2 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-accent/20 text-accent border border-accent/30'
                  : 'text-text-muted hover:text-text-primary hover:bg-surface'
              }`}
            >
              <Icon className="h-4 w-4 shrink-0" />
              <span>{tab.label}</span>
            </button>
          )
        })}
      </div>

      {activeTab === 'knowledge' && <KnowledgeAuditPanel />}
      {activeTab === 'self' && <SelfAuditPanel />}
      {activeTab === 'security' && <AuditPanel />}
    </div>
  )
}
